import { MutationTree } from "vuex";
import { IAuthState } from "./types";

export namespace AUTH_MUTATIONS {
  export const SET_USER: string = "setUser";
  export const SET_ROLES: string = "setRoles";
  export const SET_ISSUED_ROLES: string = "setIssuedRoles";
  export const SET_ISAUTHENTICATED: string = "setIsAuthenticated";
  export const SET_ISASSUMINGROLE: string = "setIsAssumingRole";
}

export const mutations: MutationTree<IAuthState> = {
  [AUTH_MUTATIONS.SET_USER](state: IAuthState, user: any): void {
    state.user = user;
  },
  [AUTH_MUTATIONS.SET_ROLES](state: IAuthState, roles: string[]): void {
    state.roles = roles;
  },
  [AUTH_MUTATIONS.SET_ISSUED_ROLES](state: IAuthState, roles: string[]): void {
    state.issuedRoles = roles;
  },
  [AUTH_MUTATIONS.SET_ISAUTHENTICATED](
    state: IAuthState,
    isAuthenticated: boolean
  ): void {
    state.isAuthenticated = isAuthenticated;
  },
  [AUTH_MUTATIONS.SET_ISASSUMINGROLE](
    state: IAuthState,
    isAssumingRole: boolean
  ): void {
    state.isAssumingRole = isAssumingRole;
  }
};
